<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>

              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t('global.save') }}
                  </button>
                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />
                    {{ $t('global.tolist') }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="isAdmin && editable && id"
                  >
                    <font-awesome-icon icon="fa-duotone fa-trash" />
                    <span>{{ $t('global.delete') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Linke Seite -->
        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <container-headline
            :headline="$t('global.masterdata')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider rules="required" v-slot="{ passed }">
                        <input
                          v-model="benutzer.vorname"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label :class="{ 'text-danger': !passed }">
                          {{ $t('global.firstname') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider rules="required" v-slot="{ passed }">
                        <input
                          v-model="benutzer.nachname"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label :class="{ 'text-danger': !passed }">
                          {{ $t('global.surname') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-8">
                    <div class="form-group">
                      <ValidationProvider rules="required" v-slot="{ passed }">
                        <input
                          v-model="benutzer.loginName"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label :class="{ 'text-danger': !passed }">
                          {{ $t('global.loginname') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-4 d-flex align-items-center">
                    <div class="form-group mb-0">
                      <b-form-checkbox
                        v-model="benutzer.aktiv"
                        :disabled="!editable"
                      >
                        {{ $t('global.active') }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Rechte Seite -->
        <div class="col-xl-6 pl-4" :class="{ 'col-xl-12': !showNavbar }">
          <container-headline
            :headline="$t('global.categorization')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="col-form-label">zugeordnete Gruppen</label>
                      <div class="border rounded p-2">
                        <b-form-checkbox
                          v-for="gruppe in benutzergruppen"
                          :key="gruppe.id"
                          v-model="ausgewaehlteGruppenIds"
                          :value="gruppe.id"
                          :disabled="!editable"
                        >
                          {{ gruppe.bezeichnung }}
                        </b-form-checkbox>
                        <span v-if="benutzergruppen.length === 0" class="text-muted small">
                          Keine Gruppen verfügbar
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="benutzer.dashboard"
                        label="bezeichnung"
                        :options="dashboards"
                        :disabled="!editable"
                        placeholder="Dashboard"
                      >
                        <span slot="no-options">{{
                          $t('global.taptosearch')
                        }}</span>
                      </v-select>
                      <label>Dashboard</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Beschreibung -->
        <div class="col-xl-12 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <container-headline
            :headline="$t('global.description')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <textarea
                        v-model.trim="benutzer.beschreibung"
                        class="form-control"
                        placeholder=" "
                        rows="4"
                        :readonly="!editable"
                      ></textarea>
                      <label>{{ $t('global.description') }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Beschäftigung -->
        <div class="col-xl-6 pr-4">
          <div class="row">
            <div
              class="col-xl-12 block block-kopf"
              style="cursor: pointer"
              @click="sektionenKollabiert = !sektionenKollabiert"
            >
              <span class="primary-headline-text mr-2">{{ $t('global.employment') }}</span>
              <font-awesome-icon
                icon="fa-solid fa-circle-info"
                class="text-muted mr-2"
                style="font-size: 0.85rem"
                v-b-tooltip.hover
                title="Daten können auch bei der Person direkt ausgefüllt werden"
                @click.stop
              />
              <font-awesome-icon v-if="sektionenKollabiert" icon="fa-solid fa-chevron-down" class="text-muted" style="font-size: 0.85rem" />
              <font-awesome-icon v-else icon="fa-solid fa-chevron-up" class="text-muted" style="font-size: 0.85rem" />
            </div>
          </div>
          <div class="row mb-3" v-show="!sektionenKollabiert">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.mitarbeiternummer"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.personnelnumber') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.position"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>Position</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.email"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.email') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <date-picker
                        :initial="benutzer.geburtstag"
                        :disabled="!editable"
                        :show-icon="true"
                        @update="(val) => (benutzer.geburtstag = val)"
                      />
                      <label>{{ $t('global.dateofbirth') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <date-picker
                        :initial="benutzer.eintritt"
                        :disabled="!editable"
                        :show-icon="true"
                        @update="(val) => (benutzer.eintritt = val)"
                      />
                      <label>{{ $t('global.entry') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <date-picker
                        :initial="benutzer.austritt"
                        :disabled="!editable"
                        :show-icon="true"
                        @update="(val) => (benutzer.austritt = val)"
                      />
                      <label>{{ $t('global.exit') }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Kontakt & Adresse -->
        <div class="col-xl-6 pl-4">
          <div class="row">
            <div
              class="col-xl-12 block block-kopf"
              style="cursor: pointer"
              @click="sektionenKollabiert = !sektionenKollabiert"
            >
              <span class="primary-headline-text mr-2">{{ $t('global.address') }}</span>
              <font-awesome-icon
                icon="fa-solid fa-circle-info"
                class="text-muted mr-2"
                style="font-size: 0.85rem"
                v-b-tooltip.hover
                title="Daten können auch bei der Person direkt ausgefüllt werden"
                @click.stop
              />
              <font-awesome-icon v-if="sektionenKollabiert" icon="fa-solid fa-chevron-down" class="text-muted" style="font-size: 0.85rem" />
              <font-awesome-icon v-else icon="fa-solid fa-chevron-up" class="text-muted" style="font-size: 0.85rem" />
            </div>
          </div>
          <div class="row mb-3" v-show="!sektionenKollabiert">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-8">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.strasse"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.street') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.hausnummer"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>Nr.</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-4">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.plz"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.zip') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-8">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.ort"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.city') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.festnetz"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.phoneb') }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model.trim="benutzer.handy"
                        class="form-control"
                        placeholder=" "
                        :readonly="!editable"
                      />
                      <label>{{ $t('global.mobilephone') }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Passwort setzen -->
        <div v-if="editable" class="col-xl-6 pr-4">
          <container-headline
            headline="Passwort setzen"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        type="password"
                        v-model="neuesPasswort"
                        class="form-control"
                        placeholder=" "
                        autocomplete="new-password"
                      />
                      <label>Neues Passwort</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        type="password"
                        v-model="neuesPasswortBestaetigen"
                        class="form-control"
                        placeholder=" "
                        autocomplete="new-password"
                      />
                      <label>Passwort bestätigen</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="passwortFehler">
                  <div class="col-xl-12">
                    <span class="text-danger small d-block">{{ passwortFehler }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MFA Konfiguration -->
        <div v-if="id && benutzer.personId" class="col-xl-12 pr-4">
          <container-headline
            headline="MFA"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <mfa-reiter
                  :person="benutzer.personId"
                  :shown="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal
      id="benutzer-loeschen-modal"
      @confirmed="benutzerloeschen"
    />
  </div>
</template>

<script>
import HeadMenu from '@/components/HeadMenu'
import ContainerHeadline from '@/components/ContainerHeadline'
import Navbar from '@/components/Navbar'

import { apiErrorToAlert } from '@/utils/Errorhandler'

import Api from '@/api/AppApi'
import store from '@/store'

import page from '@/mixins/Page'
import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'
import LoeschenModal from '@/components/Modals/LoeschenModal'
import MfaReiter from '@/pages/Geschaeftspartner/MfaReiter.vue'
import DatePicker from '@/components/Datepicker'

export default {
  name: 'Benutzer',
  components: {
    HeadMenu,
    Navbar,
    ContainerHeadline,
    LoeschenModal,
    UnsavedChangesModal,
    MfaReiter,
    DatePicker,
  },
  mixins: [page, ChangeWatcherNew],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
      isAdmin: false,
      benutzer: {
        vorname: '',
        nachname: '',
        loginName: '',
        aktiv: true,
        beschreibung: '',
        personId: null,
        dashboard: null,
        geburtstag: null,
        mitarbeiternummer: '',
        strasse: '',
        hausnummer: '',
        plz: '',
        ort: '',
        festnetz: '',
        handy: '',
        eintritt: null,
        austritt: null,
        position: '',
        email: '',
      },
      sektionenKollabiert: true,
      ausgewaehlteGruppenIds: [],
      benutzergruppen: [],
      dashboards: [],
      neuesPasswort: '',
      neuesPasswortBestaetigen: '',
    }
  },
  computed: {
    navbarTitel: function () {
      if (this.id) {
        return this.$t('global.user')
      } else {
        return this.$t('global.newuser')
      }
    },
    passwortFehler() {
      if (!this.neuesPasswort && !this.neuesPasswortBestaetigen) return null
      if (this.neuesPasswort !== this.neuesPasswortBestaetigen) {
        return 'Passwörter stimmen nicht überein'
      }
      if (this.neuesPasswort.length < 8) {
        return 'Passwort muss mindestens 8 Zeichen haben'
      }
      return null
    },
    passwortGueltig() {
      return (
        this.neuesPasswort.length >= 8 &&
        this.neuesPasswort === this.neuesPasswortBestaetigen
      )
    },
  },
  created() {
    this.loading = true
    this.ladeBenutzergruppen()
    this.ladeDashboards()
    this.ladeBenutzer()
  },
  mounted() {
    if (this.gruppen.find((gruppe) => gruppe.id == this.$CONST('GRUPPEN').ADMIN)) {
      this.isAdmin = true
    }
  },
  methods: {
    ladeBenutzergruppen() {
      Api.get('stammdaten/benutzergruppe/').then((response) => {
        this.benutzergruppen = response.data
      })
    },

    ladeDashboards() {
      Api.get('stammdaten/dashboard/').then((response) => {
        this.dashboards = response.data
      })
    },

    ladeBenutzer() {
      if (this.id) {
        Api.get('stammdaten/mitarbeiter/', { params: { id: this.id } })
          .then((response) => {
            this.initializeBenutzer(response.data)
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.editable = true
        this.loading = false
      }
    },

    initializeBenutzer(benutzer) {
      if (benutzer) {
        this.benutzer = benutzer
        this.ausgewaehlteGruppenIds = (benutzer.benutzergruppen || []).map(
          (g) => g.id
        )

        this.editable = this.isAdmin

        this.initializeChangewatcher(['benutzer'])
      } else {
        console.error('benutzer ist null')
      }
    },

    abbrechen() {
      this.$router.push({ name: 'benutzer-liste' })
    },

    speichern() {
      if (this.loading) return
      this.loading = true

      var json = Object.assign({}, this.benutzer, {
        benutzergruppen: this.ausgewaehlteGruppenIds.map((id) => {
          const g = this.benutzergruppen.find((bg) => bg.id === id)
          return { id, bezeichnung: g ? g.bezeichnung : '' }
        }),
      })

      if (!this.id) {
        Api.post('stammdaten/mitarbeiter/', json)
          .then(async (response) => {
            const newId = response.data.id
            this.initializeBenutzer(response.data)

            // If a password was entered during creation, set it now
            if (this.passwortGueltig && newId) {
              try {
                await Api.post(
                  'stammdaten/mitarbeiter/passwort/',
                  { password: this.neuesPasswort },
                  { params: { id: newId } }
                )
                this.neuesPasswort = ''
                this.neuesPasswortBestaetigen = ''
              } catch (e) {
                this.$notify(apiErrorToAlert(e))
              }
            }

            this.$notify({ type: 'success', title: this.$t('global.actionsuccessful') })

            this.$router.replace({
              name: 'benutzer',
              params: { id: newId, anzeige: 0 },
            })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        Api.put('stammdaten/mitarbeiter/', json, { params: { id: this.id } })
          .then(async (response) => {
            this.initializeBenutzer(response.data)

            if (this.passwortGueltig) {
              try {
                await Api.post(
                  'stammdaten/mitarbeiter/passwort/',
                  { password: this.neuesPasswort },
                  { params: { id: this.id } }
                )
                this.neuesPasswort = ''
                this.neuesPasswortBestaetigen = ''
              } catch (e) {
                this.$notify(apiErrorToAlert(e))
              }
            }

            this.$notify({ type: 'success', title: this.$t('global.actionsuccessful') })
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e))
          })
          .finally(() => {
            this.loading = false
          })
      }
    },


    oeffneLoeschenModal() {
      this.$bus.$emit('openLoeschenModal', 'benutzer-loeschen-modal')
    },

    benutzerloeschen() {
      Api.delete('stammdaten/mitarbeiter/', { data: [this.id] }).then(() => {
        this.$router.push({ name: 'benutzer-liste' })
      })
    },
  },
}
</script>

<style></style>